import { getGroupAuthType } from "@/utils/authToken";
import { httpAuth } from "@/api/httpAuth";
import { toastMessageTypes } from "@/redux/actions/toaster";

import { GROUP_AUTH_HEADER_NAME } from "../constants";

export const paymentRequests = {
  fetchPatientCardInfo: ({ context, data } = {}) => {
    return httpAuth
      .post("/v3/payment/get_user_payment_info", {
        context,
        headers: { [GROUP_AUTH_HEADER_NAME]: getGroupAuthType() },
        json: data,
      })
      .json();
  },
  fetchPatientPaywall: ({ context } = {}) => {
    return httpAuth.post("/v2/payment/paywall_check", { context }).json();
  },
  fetchTransactionHistory: ({ context, data } = {}) => {
    return httpAuth
      .post("/v1/payment/get_user_payment_history", {
        context: { toastErrorType: toastMessageTypes.error_v2, ...context },
        json: data,
      })
      .json();
  },
  getPaymentSessionToken: ({ context, data } = {}) => {
    return httpAuth.post("/v2/payment/session_token", { context, json: data }).json();
  },
  manualCharge: ({ context, data } = {}) => {
    return httpAuth
      .post("/v1/payment/manual_charge", {
        context: { toastErrorType: toastMessageTypes.error_v2, ...context },
        headers: { [GROUP_AUTH_HEADER_NAME]: getGroupAuthType() },
        json: data,
      })
      .json();
  },
  putPatientCardInfo: ({ context, data } = {}) => {
    return httpAuth.post("/v2/payment/method", { context, json: data }).json();
  },
};
